@if (validValue()) {
  <td-wb-icon [decorative]="false"
              [aria-label]="ariaLabel() ?? computedAriaLabel()"
              [aria-labelledby]="ariaLabelledBy()"
              [iconId]="iconId()"
              [size]="size()" />
}
